import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'js-cookie';
import settings from 'front-settings';

import { Button, notification } from 'antd';
import CMSPage from 'components/CMSPage';

const cookieOptions = {
  expires: 364,
};

if (settings.COOKIE_HOST) {
  cookieOptions.domain = settings.COOKIE_HOST;
}

class CookieNotice extends React.PureComponent {
  state = {
    shown: false,
  };

  cookieId = 'cookie-notice';

  portalRootId = 'user-notice';

  componentDidMount () {
    const alreadyDismissed = Cookies.get(this.cookieId) === 'dismissed';

    if (!alreadyDismissed) {
      notification.destroy();
      notification.info({
        duration: 0,
        placement: 'bottomRight',
        key: this.portalRootId,
        onClose: this.dismiss,
        btn: <Button type="primary" onClick={this.dismiss}>Accepter</Button>,
        description: <div id={this.portalRootId} />,
        className: 'no-print',
      });

      setTimeout(() => this.setState({ shown: true }), 0);
    }
  }

  dismiss = () => {
    Cookies.set(this.cookieId, 'dismissed', cookieOptions);
    notification.close(this.portalRootId);
    this.setState({ shown: false });
  };

  render () {
    const { children = null } = this.props;
    const portalRoot = document.querySelector(`#${this.portalRootId}`);

    if (portalRoot && this.state.shown) {
      return ReactDOM.createPortal((
        <React.Fragment>
          <CMSPage slug={this.cookieId} />
          {children}
        </React.Fragment>
      ), portalRoot);
    }

    return null;
  }
}

export default CookieNotice;



// WEBPACK FOOTER //
// ./src/components/CookieNotice/CookieNotice.js